import { render, staticRenderFns } from "./stepText.vue?vue&type=template&id=334457b2&scoped=true&"
import script from "./stepText.vue?vue&type=script&lang=ts&"
export * from "./stepText.vue?vue&type=script&lang=ts&"
import style0 from "./stepText.vue?vue&type=style&index=0&id=334457b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334457b2",
  null
  
)

export default component.exports